// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "v2.0.0-" + chunkId + "." + {"155":"ca9e39eb7e774c6009df","188":"73fd448c494e417c4f13","316":"6d5d3319e6ba64be37a8","460":"c1426c62e4814a8dbdb7","596":"c8eca91708eab95fe23c","758":"8a12a4045320395e37d3","931":"02035d56dc655335c975","977":"5fc9b638db23ecd690d8"}[chunkId] + ".js";
};